import "./EventResourceCard.css";

import { useState, useRef, useEffect } from "react";
import { Card } from "@tennr/frontend/components/Card";
import { VideoPlayer, VideoPlayerProps } from "../VideoPlayer";
import { Button } from "../Button";

type EventResourceProps = {
  title: string;
  image?: string;
  date: string;
  location?: string;
  type?: string;
  url?: URL;
  contentType: string;
  video: VideoPlayerProps
};

export const EventResourceCard = (props: EventResourceProps) => {    
  const videoRef = useRef<HTMLElement>(null);
  const linkRef = useRef<HTMLElement>(null);
  
  function stopDefault(e: React.MouseEvent){    
    if (videoRef.current && videoRef.current.contains(e.target as Node)) {
      e.preventDefault()
    }
  }

  useEffect(() => {
    if (linkRef?.current) {
      linkRef.current.addEventListener('click', stopDefault);
    }       
  }, []);
    
  
  return (
    <Card
      className={`event-resource${undefined !== props.image && props.type !== "event" ? " with-img" : ""}${props.type !== "event" ? "" : " event"} ${props.idx !== undefined && props.idx < 4 ? "extra-padding" : ""}`}
    >
      <a href={props.url} target="_blank" ref={linkRef}>
        { props.image && !props?.video &&
          <div className="img-wrap">
            <img src={props.image} alt={props.title} />
          </div>
        }
        { props?.video && 
          <VideoPlayer {...props.video } poster={ props?.image} ref={videoRef}/>              
        }
        <div className="event-resource-details">
          {props.date && <span className="event-resource-date">{props.date}</span> }
          <h4>{props.title}</h4>
          {props.location && <span className="event-resource-location">{props.location}</span>}
          <span className="event-resource-type">{props.contentType}</span>
        </div>
      </a>
    </Card>
  );
};
